module.exports = __webpack_public_path__ + "static/img/pro_display_7.7587c92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productDisplay/pro_display_7.jpg
// module id = Op6S
// module chunks = 1